import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Modal from '../../../../core/modules/common/components/Modal';

const XlsExportLoadingModal = (props) => {
  const {
    closeModal,
  } = props;
  return (
    <Modal
      header={
        <FormattedMessage
          id="app.warning.download.loading"
          tagName="h5"
        />
      }
      closeOnOutsideClick
      onClose={closeModal}
    />
  );
};

XlsExportLoadingModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default XlsExportLoadingModal;
